var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 10C9.75717 10 11.9997 7.7575 11.9997 5C11.9997 2.2425 9.75717 0 6.99967 0C4.24217 0 1.99967 2.2425 1.99967 5C1.99967 7.7575 4.24217 10 6.99967 10ZM6.99967 11.6667C3.32384 11.6667 0.333008 14.6575 0.333008 18.3333V19.1667C0.333008 19.6267 0.705508 20 1.16634 20H12.833C13.2938 20 13.6663 19.6267 13.6663 19.1667V18.3333C13.6663 14.6575 10.6755 11.6667 6.99967 11.6667Z",
    fill: "#474E58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMan);
export default __webpack_public_path__ + "static/media/IconMan.6616463de07313e1a5734d9830d360be.svg";
export { ForwardRef as ReactComponent };